import {createContext} from 'react';

const retiroDU038Context = createContext();

export default retiroDU038Context;